// 工具方法
import axios from 'axios'
// const BaseURL = 'http://yswapi.albers.top/api'
// 接口请求
export default class HttpServer {
  /**
   * @static get请求
   * @param {*} url
   * @param {*} params
   * @returns
   * @memberof HttpServer
   */
  static get (url, params) {
    return new Promise((resolve, reject) => {
      axios.get(url, params).then(res => {
        if (res.status === 200) {
          resolve(res.data)
        }
      }).catch(e => {
        reject(e)
      })
    })
  }
  /**
   * @static post请求
   * @param {*} url
   * @param {*} params
   * @returns
   * @memberof HttpServer
   */
  static post (url, params) {
    return new Promise((resolve, reject) => {
      axios.post(`${url}`, params).then(res => {
        if (res.status === 200) {
          resolve(res.data)
        }
      }).catch(e => {
        reject(e.response.data)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils.js